export const appsAppGroupIdChartsWhatsapp = "/apps/:app_group_id/charts/whatsapp";
